import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function ProtectedRoutes({ children, allowed }) {
  const admin = useSelector((state) => state.admin.admin);
  const permission = useSelector((state) => state.admin.permissions || state.admin.permission || []);

  const userPerms = permission || [];
  const hasAccess = allowed?.some((p) => userPerms.includes(p));

  if (!hasAccess && admin.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoutes;
